import { useSmsAutomationAccess } from '@features/sms/useSmsAutomationAccess';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { Chip, Stack, Typography } from '@mui/material';
import AccordionSection from '../AccordionSection';
import { SmsTemplateManager } from '@features/sms/components/SmsTemplateManager';
import { SmsCreditPanel } from '@features/sms/components/SmsCreditPanel';
import { SmsHistory } from '@features/sms/components/SmsHistory';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import HistoryIcon from '@mui/icons-material/History';
import SmsIcon from '@mui/icons-material/Sms';
const SmsTemplatesSection = () => {
  const smsAutomationEnabled = useSmsAutomationAccess();
  const { t } = useIntlTranslations();
  return (
    <AccordionSection
      id="profile-sms-templates-section"
      title={t(smsAutomationEnabled ? 'myProfile.smsAutomation' : 'myProfile.smsTemplates')}
      subtitle={smsAutomationEnabled ? t('myProfile.smsAutomationSubtitle') : undefined}
      childSectionIds={[
        'profile-sms-editor-section',
        'profile-sms-history-section',
        'profile-sms-credit-section',
      ]}
    >
      <Stack spacing={1}>
        <AccordionSection
          compact
          id="profile-sms-editor-section"
          title={
            <Stack direction="row" alignItems="center" spacing={1}>
              <SmsIcon color="primary" />
              <Typography variant="h6">{t('myProfile.smsTemplates')}</Typography>
            </Stack>
          }
        >
          <SmsTemplateManager />
        </AccordionSection>
        {smsAutomationEnabled && (
          <>
            <AccordionSection
              compact
              id="profile-sms-history-section"
              title={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <HistoryIcon color="primary" />
                  <Typography variant="h6">{t('smsHistory.title')}</Typography>
                </Stack>
              }
            >
              <SmsHistory />
            </AccordionSection>
            <AccordionSection
              compact
              id="profile-sms-credit-section"
              title={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <AccountBalanceWalletOutlinedIcon color="primary" />
                  <Typography variant="h6">{t('smsCredit.title')}</Typography>
                </Stack>
              }
            >
              <SmsCreditPanel />
            </AccordionSection>
          </>
        )}
      </Stack>
    </AccordionSection>
  );
};
export default SmsTemplatesSection;
